import styled from "styled-components";
import {
  Form,
  Divider,
  Row,
  Col,
  Table,
  Icon,
  DatePicker
} from "antd";
import {
  DisplayFlex,
  GhostButtonComponent,
  PagesHeading,
  SectionLastHeading,
  SectionLastHeadingH2,
  UnderlineLink,
  PillButton,
  SecondaryButtonComponent,
  DataValue,
  CommonTable,
  InputField,
  ErrorMessage
} from "../../../../CommonComponents/commonStyles";
import theme from "../../../../styles/theme";

export const InputSection = styled(InputField)`
  padding: 4px 11px !important;
  @media only screen and (max-width: 767px) {
    max-width: unset !important;
  }
`;

export const DatePickerInput = styled(DatePicker)`
  .ant-calendar-picker-clear {
    display: none;
  }
  .ant-input {
    font-size: ${props=>props.theme.fontSize.secondary};
    font-family: ${props=>props.theme.fontFamily.helveticaNeue};
  }
  @media only screen and (min-width: 992px) {
    .ant-input {
      font-size: ${props=>props.theme.fontSize.primary};
    }
  }
`;

export const BoxDetailWrapper = styled(Col)`
  padding-top: 20px;
  padding-bottom: 20px;
  ${props =>
    props.border && `border-bottom:1px solid ${props.theme.colors.border};`}
`;

export const ErrorMsgWrap = styled(ErrorMessage).attrs(()=>({
  className: "error-fields"
  }))`
  margin-top: 5px;
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
`;

export const ErrorMsgFixedWidth = styled(ErrorMsgWrap)`
  width: 228px;
`;

export const LogoWrap = styled.div`
    width: 47px;
`;

export const FlexCenter = styled(DisplayFlex)`
  align-items: center;
`;

export const DropdownRow = styled(Row)`
  ant-row ant-form-item {
    margin-bottom: 30px;
  }
`;

export const GrantAgreementHeading = styled(PagesHeading)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h2};
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
    word-break: break-word;
  }
`;

export const GrantAgreementUnderlineLink = styled(UnderlineLink)`
  position: relative;
  line-height: unset;
  left: 2px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const GrantAgreementPrimaryButtonWrapper = styled.div`
  width: 200px;
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: ${props => props.theme.letterSpacing.buttonText};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
  }
`;

export const ButtonWrapper = styled(DisplayFlex)`
  justify-content: space-between;
  margin-top: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: row;
    margin-top: 30px;
    margin-bottom: 15px;
  }
`;

export const GrantAgreementGhostButton = styled(GhostButtonComponent)`
  width: 150px;
  margin-right: 15px;
  font-size: ${props => props.theme.fontSize.heading};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    margin-bottom: 15px;
    margin-top: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

export const GrantAgreementDisplayFlex = styled(DisplayFlex)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const GrantAgreementContent = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.textColor};
  margin-bottom:  ${props => props.marginBottom ? props.marginBottom : "10px"};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    margin-bottom: ${props => (props ? props.mobmb : "10px")}
  }
`;
export const GrantAgreementGrant = styled(GrantAgreementContent)`
  margin-top: 30px;
`;
export const GrantAgreementSubContent = styled(GrantAgreementContent)`
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
    margin-bottom: 30px;
  } 
`;

export const GrantAgreementSectionLastHeading = styled(SectionLastHeadingH2)`
margin-top:  ${props => (props ? props.marginTop : "0px")};
@media only screen and (min-width: 320px) and (max-width: 767px) {
  font-size: ${props => props.theme.fontSize.h4};
  margin-top: ${props => (props ? props.mobmt : "10px")};
  margin-bottom:  ${props => (props ? props.mobmb : "10px")};
}
`;

export const InputWrapper = styled.div`
  input,
  .ant-select-selection--single {
    height: 40px;
    width: ${props => (props ? props.inputWidth : "")};
  }
  .ant-input {
    border: solid 1px ${props => props.theme.colors.border};
    font-size: ${props=> props.theme.fontSize.secondary};
    font-family: ${props=> props.theme.fontFamily.helveticaNeue};
    border-radius: 0;
  }
  @media only screen and (min-width: 992px) {
    .ant-input {
      font-size: ${props=> props.theme.fontSize.primary};
    }
  }
`;

export const DatePickerWrapper = styled.div`
  input,
  .ant-select-selection--single {
    height: ${ props => props.height ? props.height: '40px !important' };
  }
  
  .ant-select-arrow-icon {
    display: none;
  }

  input::placeholder {
    color: #d4d4d4;
  }

  .ant-select-selection {
    border-radius: 0;
    display: flex;
    align-items: center;
    border: 1px solid #d4d4d4;
  }

  .ant-input {
    border-radius: 0;
    color: ${props => props.theme.fontColors.thead};
    font-size: ${props => props.theme.fontSize.primary};    
    font-family: ${props => props.theme.fontFamily.helveticaNeue};    
    width: 266px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      font-size: ${props => props.theme.fontSize.secondary} !important;
    }
  }

  .ant-calendar-picker-input {
    margin-top: 0 !important;
  }

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    input,
    .ant-select-selection--single {
      width: 279px;
    }
  }

`;

export const WrapLabel = styled.div`
&&& {
  .ant-form-item-label{
    margin-bottom: 10px;
   }
   @media only screen and (min-width: 320px) and (max-width: 767px) {  
    &&& {
      .ant-form-item-label{
        padding: 0;
       }
   }  
}
}
`;

export const LabelWrapper = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  font-weight: ${props => props.theme.fontWeight.normal};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const GrantAgreementSectionSubHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  margin-bottom: 10px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    line-height: ${props => props.theme.lineHeight.tableFont};
  }
`;

export const InputMargin = styled.div`
  .ant-form-item {
    margin-bottom: ${props => (props ? props.marginBottom : "40px")};
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .ant-form-item {
      margin-bottom: 30px;
    }
  }
`;
export const GrantAllocationInputMargin = styled(InputMargin)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .ant-form-item {
      margin-bottom: 15px;
    }
  }
`;

export const FormContainer = styled(Form)`
  &&& {
    .ant-form-item-control .ant-calendar-picker,
    .ant-input-number {
      width: 100%;
    }
    .ant-form-item-control {
        line-height: normal;
      }
    }
`;

export const GrantsDivider = styled(Divider)`
&&&
.ant-divider, 
  .ant-divider-horizontal{
    margin-bottom: ${props => (props ? props.marginBottom : "50px")};
    margin-top: ${props => (props ? props.marginTop : "10px")};
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  &&&
.ant-divider, 
  .ant-divider-horizontal{
    margin-bottom: ${props => (props ? props.marginBottom : "30px")};
    margin-top: ${props => (props ? props.marginTop : "10px")};
}
}
`;

export const PaymentDivider = styled(GrantsDivider)`
  background: ${props => props.theme.colors.lightGrey};
  position: static;
`;

export const ContentWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-stretch: normal;
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.thead};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const GrantPillButton = styled(PillButton)`
color: ${props => props.theme.fontColors.primary};
border:1px solid ${props => props.theme.fontColors.primary};
font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
background-color: ${props => props.theme.backgroundColor.pill};
border: 1px solid ${props => props.theme.border.pill};
&:hover, &:focus{
  color:${props => props.theme.fontColors.primary};
  border:1px solid ${props => props.theme.fontColors.primary};
}
`;

export const TableLabel = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.raeCardFooter};
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const SearchResultText = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.heading};
  margin-bottom: 5px;
  color: ${props => props.theme.fontColors.thead};
`;

export const GrantsTable =  styled(CommonTable)``;

export const UnderlyingContent = styled(UnderlineLink)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.tableFont};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
`;
export const FloatCard = styled.div``
export const CardWrapper = styled.div``;
export const GrantTermWrapper = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  margin-top: 25px;
  ${({ paddingBottom }) =>
    paddingBottom &&
    `
  padding-bottom: 50px;
`}
`;

export const GrantSecondaryButtonComponent = styled(SecondaryButtonComponent)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.secondary};
  > span {
    padding: 3px 3px 0px 0px;
    font-style: normal;
    font-stretch: normal;
    line-height: ${props => props.theme.lineHeight.normal};
    letter-spacing: ${props => props.theme.letterSpacing.zero};
  }
  @media only screen and (max-width: 991.92px) {
    width: 135px;
  }
`;

export const ConfirmationNotes = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  ${({ lineHeight }) => (lineHeight ? `line-height:26px` : ``)}
`;

export const ConfirmationRules = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
`;

export const GrantSectionHeading = styled(SectionLastHeading)`
  font-family: ${props => props.theme.fontFamily.berkeleyStd};
  font-size: ${props => props.theme.fontSize.h4};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.h5};
  }
`;

export const SectionMediumDivider = styled(Divider)`
  border-bottom: solid 1px ${props => props.theme.colors.border};
  margin-top: ${props => (props.smallMarginTop ? "30px" : "40px")};
  margin-bottom: ${props => (props.smallMarginBottom ? "30px" : "40px")};
  @media only screen and (min-width: 767px) {
    margin-top: ${props => (props.smallMarginTop ? "30px" : "49px")};
    margin-bottom: ${props => (props.smallMarginBottom ? "30px" : "50px")};
  }
`;

export const CharitySectionDivider = styled(Divider)`
  border-bottom: solid 1px ${props => props.theme.colors.border};
  top: unset;
  margin-top: 0px;
  margin-bottom: 20px;
 @media only screen and (min-width: 992px) {
    margin-top: 0px;
   margin-bottom: 20px;
 }
`

export const ScrollUp = styled(CharitySectionDivider).attrs(()=>({
  className: "scrollUp"
  }))`` 

export const CustomisedIcon = styled(Icon)`
color: ${theme.fontColors.primary};
`;

export const GeminiName = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color:${props => props.theme.fontColors.primary};
`;

export const Title = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
font-size: ${props => props.theme.fontSize.primary};
font-style: ${props => props.theme.fontWeight.normal};
font-stretch: ${props => props.theme.fontStretch.normal};
line-height: ${props => props.theme.lineHeight.primary};
letter-spacing: ${props => props.theme.letterSpacing.normal};
color: ${props => props.theme.fontColors.headingColor};
`;

export const StyleLessButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`;

export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  margin-right: ${props => (props.primary ? "50px" : "")};
  @media (max-width: 990px) {
    margin-left: 0px;
    margin-right: 20px;
  }
`;

export const DisclaimerContainer = styled.div`
  margin-top:40px;
`;

export const FloaterContainer = styled.div`
  position: absolute;
  height: calc(100% - 101px);
  right: 0;
  width: 272px;
`

export const DataExportPrint = styled(DataValue)`
  margin: 0px 5px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
  display: block;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: underline;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
  }
`;

export const Block = styled.div`
${({ h }) => (h ? `height:${h}px;` : ``)}
${({ w }) => (w ? `width:${w}px;` : ``)}
${({ mt }) => (mt ? `margin-top: ${mt}px;` : ``)}
${({ mr }) => (mr ? `margin-right: ${mr}px;` : ``)}
${({ ml }) => (ml ? `margin-left: ${ml}px;` : ``)}
${({ mb }) => (mb ? `margin-bottom :${mb}px;` : ``)}
${({ pl }) => (pl ? `padding-left:${pl}px;` : ``)}
${({ pr }) => (pr ? `padding-right: ${pr}px; ` : ``)}
${({ auto }) => (auto ? `width:auto q q   ` : ``)}
${({ flex }) =>
  flex === 2 ? `display:flex;flex-direction:column` : `display:flex;`}
${({ pos }) =>
  pos === "left" ? `justify-content:flex-start; align-items:center` : ``}
${({ pos }) =>
  pos === "right" ? `justify-content:flex-end; align-items:center` : ``}
${({ fixEnds }) => (fixEnds ? `justify-content:space-between;` : ``)}
${({ alignTop }) => (alignTop ? `align-items:flex-start;` : ``)}
${({ center }) => (center ? `justify-content:center;align-items:center` : ``)}
`;

export const SectionDivider = styled.div`
  border-bottom: 1px solid ${props => props.theme.border.filledTabsInactive};
  margin: 50px 0 50px 0;
`;

export const PreloaderController = styled.div`
  & img {
    padding: 0;
    width: 50px;
    height: 50px;
  }
`;
export const SectionMediumDividerPrint = styled(SectionMediumDivider)`
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const ConfirmationContent = styled.div`
  p{
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
  }
`;

export const AlertWrap = styled.div`
  >div >p {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    font-weight: ${props => props.theme.fontWeight.normal};
    font-style: normal;
    font-stretch: ${props => props.theme.fontStretch.normal};
    line-height: ${props => props.theme.lineHeight.primary};
    letter-spacing: normal;
    text-align: center;
    color: ${props => props.theme.fontColors.textColor};
    @media (min-width: 320px) and (max-width: 768px){
      >div >p {
        font-size: ${props => props.theme.fontSize.secondary};
        letter-spacing: ${props => props.theme.letterSpacing.normal};
      }
    }
  }
`;
export const BtnWrapper = styled.div`
  >button{
    margin-right:15px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-right:0px;
    margin-top:20px;
    margin-bottom:15px;
    width:100%;
  }
  }
`
export const Wrapper = styled.div`
>button{
  width:100%;
}
`